import Card from "./card.component"
export default Card;
